<mat-card>

    <mat-card-header>
        <mat-card-title>
            <div class="flex-row flex-gap-10">
                <div *ngFor="let tab of tabs; let i = index">
                    <span class="case-count click" [ngClass]="{'case-count-active': tab.active}" (click)="setActiveTab(i)">
                        {{tab.title}}&nbsp;({{caseCount[i]}})
                    </span>
                </div>    
            </div>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <app-case-events-list *ngIf="(tabs[0].active)"></app-case-events-list>
        <app-case-documents-list *ngIf="(tabs[1].active)"></app-case-documents-list>
    </mat-card-content>

</mat-card>